'use client'
import React from 'react'
import { cn, trackEvent } from '@/lib/utils'
import { Link } from 'next-view-transitions'

export const Button = ({
  href,
  as: Tag = 'a',
  children,
  className,
  variant = 'primary',
  traceEvent,
  ...props
}: {
  href?: string
  as?: React.ElementType
  children: React.ReactNode
  className?: string
  variant?: 'primary' | 'secondary' | 'dark' | 'gradient' | 'none'
  traceEvent?: { event: string; data?: Record<string, unknown> }
} & (React.ComponentPropsWithoutRef<'a'> | React.ComponentPropsWithoutRef<'button'> | typeof Link)) => {
  const baseStyles = 'px-4 py-2 rounded-full button bg-white text-black text-sm font-normal relative cursor-pointer inline-block text-center'
  const handleClick = () => {
    if (traceEvent?.event) {
      trackEvent(traceEvent?.event, traceEvent?.data)
    }
  }
  const variantStyles = {
    primary: 'bg-accent hover:bg-aitubiao hover:-translate-y-0.5 transition duration-200',
    secondary: 'shadow-none',
    dark: 'bg-black text-white shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset]',
    gradient: 'bg-gradient-to-b from-blue-500 to-blue-700 text-white shadow-[0px_2px_0px_0px_rgba(255,255,255,0.3)_inset]',
    none: ''
  }

  return (
    <Tag href={href || undefined} className={cn(baseStyles, variantStyles[variant], className)} {...props} onClick={handleClick}>
      {children}
    </Tag>
  )
}
